import { render, staticRenderFns } from "./EditCourseBlock.vue?vue&type=template&id=97bfb178&"
import script from "./EditCourseBlock.vue?vue&type=script&lang=js&"
export * from "./EditCourseBlock.vue?vue&type=script&lang=js&"
import style0 from "./EditCourseBlock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports